import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import ar from './locales/ar';
import fr from './locales/fr';
import es from './locales/es';
import nl from './locales/nl';

const resources = { en: { t: en }, ar: { t: ar }, fr: { t: fr }, es: { t: es }, nl: { t: nl } };

export const SUPPORTED_LANGS = [
  { code: 'en', native: 'English', name: 'English', dir: 'ltr' },
  { code: 'ar', native: 'العربية', name: 'Arabic', dir: 'rtl' },
  { code: 'fr', native: 'Français', name: 'French', dir: 'ltr' },
  { code: 'es', native: 'Español', name: 'Spanish', dir: 'ltr' },
  { code: 'nl', native: 'Nederlands', name: 'Dutch', dir: 'ltr' },
];

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  defaultNS: 't',
  supportedLngs: SUPPORTED_LANGS.map(l => l.code),
  detection: { order: ['localStorage', 'navigator'], lookupLocalStorage: 'eureka_lang', caches: ['localStorage'] },
  interpolation: { escapeValue: false },
});

const applyDir = (lng) => {
  const entry = SUPPORTED_LANGS.find(l => l.code === lng) || SUPPORTED_LANGS[0];
  document.documentElement.lang = entry.code;
  document.documentElement.dir = entry.dir;
};
applyDir(i18n.language || 'en');
i18n.on('languageChanged', applyDir);

export default i18n;
